import { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import React from 'react';

const mapStateToProps = ( { calendarEventSound, gameprogress } ) => ( { calendarEventSound, gameprogress } );

@connect( mapStateToProps )
class EventSound extends Component {

    constructor( props ) {
        super( props );
        this.state = {
            currentAudio: '',
            currentAudio2: ''
        };

        this.linkCorrect = '';
        this.linkTimeout = '';
        this.linkWrong = '';
        this.linkHover = '';
        this.playBack = '';
        this.audioPlay = null;
        this.audioPlay2 = null;
        const { setSoundFreeze, setSoundNextPlay } = this.props;
        setSoundFreeze( this.soundFreeze );
        setSoundNextPlay( this.soundNextPlay );
    }

    componentDidMount() {
        this.audioPlay.volume = 0.8;
        this.audioPlay2.volume = 0.5;
        this.audioPlay.muted = false;
        this.audioPlay2.muted = false;
        this.linkUpdate( this.props );
    }

    soundFreeze = () => {
        this.audioPlay2.currentTime = 0;
        this.audioPlay2.muted = true;

    };

    soundNextPlay = () => {
        this.audioPlay2.currentTime = 0;
        this.audioPlay2.muted = false;
    };


    linkUpdate = ( props ) => {

        if ( props.calendar && props.calendar.audio ) {
            const { audio: { correct, timeout, wrong } } = props.calendar;
            this.linkCorrect = correct;
            this.linkTimeout = timeout;
            this.linkWrong = wrong;
        }

        if ( props.currentQuestion && props.currentQuestion.question && props.currentQuestion.question.localization && props.currentQuestion.question.localization.audio ) {
            const { localization: { audio: { hover, playback } } } = props.currentQuestion.question;
            this.linkHover = hover;
            this.playBack = playback;
        }
    };

    componentDidUpdate( prevProps  ) {
        const { setSoundFreeze, setSoundNextPlay } = this.props;
        setSoundFreeze( this.soundFreeze );
        setSoundNextPlay( this.soundNextPlay );

        if ( this.props.calendarEventSound.numberEvent !== prevProps.calendarEventSound.numberEvent ) {
            this.linkUpdate( this.props );

            new Promise( ( resolve ) => {
                this.setSound( this.props, resolve );
            } ).then( ( res ) => {
                if ( ( res === 1 ) && ( this.state.currentAudio !== '' ) ) {
                    this.audioPlay.play();
                }
                if ( ( res === 2 ) && ( this.state.currentAudio2 !== '' ) ) {
                    this.audioPlay2.play();
                }
            } );
        }
        if ( ( prevProps.animationProcess === false ) && ( this.props.componentProc === 'question' ) && ( this.state.currentAudio2 !== '' ) ) {
            if ( this.audioPlay2 && this.audioPlay2.play ) {
                this.audioPlay2.play();
            }
        }
        if ( ( prevProps.animationProcess === true ) && ( this.props.componentProc === 'question' ) && ( this.state.currentAudio2 !== '' ) ) {
            this.audioPlay2.currentTime = 0;
            this.audioPlay2.play();
        }
        if ( ( this.props.componentProc === 'cover' ) || ( prevProps.componentProc === 'intro' ) || ( this.props.componentProc === 'registration' ) || ( this.props.componentProc === 'result' ) ) {
            this.audioPlay2.currentTime = 0;
            this.audioPlay2.pause();
        }
    }


    setSound = ( props, callBack ) => {
        const { calendarEventSound: { events } } = props;

        switch ( events ) {
            case 'correct': {
                this.setState( { currentAudio: this.linkCorrect }, () => {
                    if ( typeof callBack === 'function' ) {
                        callBack( 1 );
                    }
                } );
                break;
            }

            case 'wrong': {
                this.setState( { currentAudio: this.linkWrong }, () => {
                    if ( typeof callBack === 'function' ) {
                        callBack( 1 );
                    }
                } );
                break;
            }

            case 'timeout': {
                this.setState( { currentAudio: this.linkTimeout }, () => {
                    if ( typeof callBack === 'function' ) {
                        callBack( 1 );
                    }
                } );
                break;
            }

            case 'hover': {
                this.setState( { currentAudio: this.linkHover }, () => {
                    if ( typeof callBack === 'function' ) {
                        callBack( 1 );
                    }
                } );
                break;
            }

            case 'playback': {
                this.setState( { currentAudio2: this.playBack }, () => {
                    if ( typeof callBack === 'function' ) {
                        callBack( 2 );
                    }
                } );
                break;
            }

            default:
                this.setState( { currentAudio: '' }, () => {
                    if ( typeof callBack === 'function' ) {
                        callBack( 1 );
                    }
                } );
        }
    };

    render() {
        return (
            <Fragment>
                <audio ref={ ( elm ) => {
                    this.audioPlay = elm;
                } } src={ this.state.currentAudio }>
                    <source src={ this.state.currentAudio } type='audio/mpeg'/>
                </audio>
                <audio ref={ ( elm ) => {
                    this.audioPlay2 = elm;
                } } src={ this.state.currentAudio2 }>
                    <source src={ this.state.currentAudio2 } type='audio/mpeg'/>
                </audio>
            </Fragment>
        );
    }
}

export default EventSound;